import type { ReactNode } from 'react'
import './editor-page-layout.css'

interface EditorPageLayoutProps {
	toolbar: ReactNode
	header: ReactNode
	canvasArea: ReactNode
	sidePanel?: ReactNode
	overlay?: ReactNode
	className?: string
	as?: 'div' | 'main'
}

export function EditorPageLayout({
	toolbar,
	header,
	canvasArea,
	sidePanel,
	overlay,
	className,
	as: Element = 'div',
}: EditorPageLayoutProps) {
	return (
		<Element className={`editor-page ${className ?? ''}`}>
			{toolbar}
			<div className="editor-page__content">
				{header}
				<div className="editor-page__main">
					{canvasArea}
					{sidePanel}
				</div>
				{overlay}
			</div>
		</Element>
	)
}
